// extracted by mini-css-extract-plugin
export var bg = "Designers-module--bg--59d77";
export var core = "Designers-module--core--f42d1";